var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElinoiLogoLabelAqua(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 262,
    viewBox: "0 0 541 262",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 541,
    height: 262,
    fill: "#8FF6EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1748 58.9272V224.997H129.611V192.02H106.128V154.299H128.901V121.322H106.128V91.9038H129.377V58.9272H68.1748Z",
    fill: "#222426"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.953 58.9272V224.997H196.389V192.02H173.051V58.9272H134.953Z",
    fill: "#222426"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.061 224.997H237.347V58.9272H199.061V224.997Z",
    fill: "#222426"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M295.167 58.9272L304.513 159.044H302.357L284.385 58.9272H242.689V224.997H281.031L272.641 125.594H274.8L291.812 224.997H333.508V58.9272H295.167Z",
    fill: "#222426"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_2416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 338,
    y: 56,
    width: 89,
    height: 171
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M338.858 56.2041H426.382V226.773H338.858V56.2041Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_2416)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M377.015 186.026C377.015 191.71 379.64 193.845 382.5 193.845C385.6 193.845 388.225 191.71 388.225 186.026V96.9509C388.225 91.0302 385.6 89.1355 382.5 89.1355C379.64 89.1355 377.015 91.0302 377.015 96.9509V186.026ZM382.023 56.2041C409.45 56.2041 426.382 71.3677 426.382 99.7944V182.946C426.382 211.612 409.45 226.773 382.023 226.773C354.835 226.773 338.858 211.849 338.858 182.946V99.7944C338.858 70.8919 354.835 56.2041 382.023 56.2041Z",
    fill: "#222426"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_2416",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 68,
    y: 15,
    width: 403,
    height: 212
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1748 226.773H470.626V15.4116H68.1748V226.773Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_2416)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M431.632 224.405H470.027V58.5747H431.632V224.405Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.999 25.2405L86.7799 47.946L79.0527 37.9623L108.341 15.4106L115.999 25.2405Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M470.627 39.2341L461.792 30.4585L452.958 39.2341L461.792 48.0097L470.627 39.2341Z",
    fill: "#222426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.297 39.2341L440.462 30.4585L431.628 39.2341L440.462 48.0097L449.297 39.2341Z",
    fill: "#222426"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElinoiLogoLabelAqua);
export default __webpack_public_path__ + "static/media/elinoi-logo-label-aqua.968ab0e7efd67480a6f2b9a3b0b0387f.svg";
export { ForwardRef as ReactComponent };